// Industry Experience slides.
//
// These are 960x540 WebP exports of the original PowerPoint slides. The source
// PNGs in src/assets are 2048x1152 (Aerospace was 4096x2304) and totalled ~55MB
// for the set; at the ~460 CSS px these render at, 960w is already generous.
// All seventeen together are under 0.7 MB.
//
// The industry name is baked into the image artwork, which is why `title`
// doubles as the alt text without being redundant -- and why these titles are
// not free text. Each one has to keep matching the slide it labels.
//
// This list was briefly cut to the four that content/contact.ts's FAQ calls
// out, then restored. See REMEDIATION_NOTES.md for what is and is not
// evidenced here.
import aerospace from '../../assets/industries/aerospace.webp';
import automotive from '../../assets/industries/automotive.webp';
import banking from '../../assets/industries/banking.webp';
import chemical from '../../assets/industries/chemical.webp';
import consumerGoods from '../../assets/industries/consumer-goods.webp';
import datacenters from '../../assets/industries/datacenters.webp';
import entertainment from '../../assets/industries/entertainment.webp';
import foodService from '../../assets/industries/food-service.webp';
import fortune500 from '../../assets/industries/fortune-500.webp';
import insurance from '../../assets/industries/insurance.webp';
import manufacturing from '../../assets/industries/manufacturing.webp';
import medTech from '../../assets/industries/med-tech.webp';
import military from '../../assets/industries/military.webp';
import oil from '../../assets/industries/oil.webp';
import research from '../../assets/industries/research.webp';
import satellite from '../../assets/industries/satellite.webp';
import telecommunications from '../../assets/industries/telecommunications.webp';

export type Industry = {
  id: number;
  title: string;
  imageUrl: string;
};

/** Intrinsic size of every slide image — used to reserve the box and avoid CLS. */
export const SLIDE_WIDTH = 960;
export const SLIDE_HEIGHT = 540;

export const INDUSTRIES: readonly Industry[] = [
  { id: 1, title: 'Aerospace', imageUrl: aerospace },
  { id: 2, title: 'Automotive', imageUrl: automotive },
  { id: 3, title: 'Banking & Finance', imageUrl: banking },
  { id: 4, title: 'Chemical', imageUrl: chemical },
  { id: 5, title: 'Consumer Goods/Retail', imageUrl: consumerGoods },
  { id: 6, title: 'Datacenters', imageUrl: datacenters },
  { id: 7, title: 'Entertainment/Media', imageUrl: entertainment },
  { id: 8, title: 'Food Service', imageUrl: foodService },
  { id: 9, title: 'Fortune 500', imageUrl: fortune500 },
  { id: 10, title: 'Insurance', imageUrl: insurance },
  { id: 11, title: 'Manufacturing', imageUrl: manufacturing },
  { id: 12, title: 'Medtech, Health Care', imageUrl: medTech },
  { id: 13, title: 'Military', imageUrl: military },
  { id: 14, title: 'Oil', imageUrl: oil },
  { id: 15, title: 'Research', imageUrl: research },
  { id: 16, title: 'Satellite', imageUrl: satellite },
  { id: 17, title: 'Telecommunications', imageUrl: telecommunications },
];
